var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"servebox",on:{"click":_vm.goShop}},[_c('div',{staticClass:"inn"},[(_vm.num > 0)?_c('div',{staticClass:"sign"},[_vm._v(_vm._s(_vm.num))]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":require("@/imgs/shopFloat.svg"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73793a08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shopFloat.vue
// module id = null
// module chunks = 